import { Case } from '@/models';
import { CaseService, DataService, ErrorService } from '@/services';
import { Component, inject, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
    selector: 'app-ai-chat-overlay',
    templateUrl: './ai-chat-overlay.component.html',
    styleUrls: ['./ai-chat-overlay.component.scss'],
    standalone: false
})
export class AiChatOverlayComponent implements OnInit, OnChanges {
  @Input() aiChatUrl: string;

  iframeSafeUrl: any;

  @Input() cases: Case[] = [];

  private caseService = inject(CaseService);
  private dataService = inject(DataService);
  private errorService = inject(ErrorService);
  private sanitizer = inject(DomSanitizer);

  ngOnInit(): void {
    if (!this.aiChatUrl) {
      const activePatient = this.dataService.getActivePatient();
      if (!activePatient || !activePatient.id) {
        return;
      }
      this.cases.sort((a, b) => a.title.localeCompare(b.title));
      if (this.cases && this.cases.length > 0) {
        if (this.cases.length === 1) {
          this.aiChatUrl = this.cases[0].aiChatUrl;
          this.setIframeUrl(this.aiChatUrl);
        }
      }
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['aiChatUrl']) {
      const newUrl = changes['aiChatUrl'].currentValue;
      if (newUrl) {
        this.setIframeUrl(newUrl);
      }
    }
  }

  private setIframeUrl(url: string) {
    this.iframeSafeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

  selectCase(caseItem: Case) {
    this.aiChatUrl = caseItem.aiChatUrl;
    this.setIframeUrl(this.aiChatUrl);
  }
}
